import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'abs'})
export class AbsPipe implements PipeTransform {
  transform(value: number, args?: any): any {
    return Math.abs(value);
  }
}
